module.exports = __webpack_public_path__ + "static/img/son11_active.f394c46f.png";